import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formControlIndex'
})
export class FormControlIndexPipe implements PipeTransform {
  transform(questionId: string, questionIdToFormIndex: Map<string, number>): number {
    return questionIdToFormIndex.get(questionId) || 0;
  }
}
